import { combineReducers } from 'redux-immutable'
import { handleActions, combineActions } from 'redux-actions'
import { Map } from 'immutable'
import * as actions from './actions'

const status = handleActions({
  [combineActions(
    actions.fetchTagListPending,
    actions.fetchTagListFailed,
    actions.receiveTagList,
  )]: (state, action) => {
    return state.setIn(['tags', 'fetch'], action.type)
  },

  [combineActions(
    actions.createTagPending,
    actions.createTagFailed,
    actions.receiveTag,
  )]: (state, action) => {
    return state.setIn(['tag', 'create'], action.type)
  },

  [combineActions(
    actions.updateTagPending,
    actions.updateTagFailed,
    actions.receiveTag,
  )]: (state, action) => {
    return state.setIn(['tag', 'update'], action.type)
  },

  [combineActions(
    actions.deleteTagPending,
    actions.deleteTagFailed,
    actions.deleteTagSuccess,
  )]: (state, action) => {
    return state.setIn(['tag', 'delete'], action.type)
  }
}, Map())

const data = handleActions({
  [actions.receiveTagList]: (state, action) => {
    return action.payload.reduce((tagsById, tag) => {
      return tagsById.set(tag.id, tag)
    }, Map())
  },
}, Map())

export default combineReducers({
  status,
  data,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/tags/reducers.js